import { CommentFormData } from 'mk2/apps/forum/components/CommentCreateEditForm';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

///////////////////////////////////////////////////////////////////
// Progress broadcast

export interface CommentsFetchAction extends Action {
    readonly key: string;
}

export const COMMENTS_FETCH_REQUEST = 'COMMENTS_FETCH_REQUEST';
export interface CommentsFetchRequestAction extends CommentsFetchAction, APIRequestAction {
    readonly type: typeof COMMENTS_FETCH_REQUEST;
}

export interface CommentsFetchNormalizedResponse extends NormalizedResponse {
    readonly result: number[];
}
export const COMMENTS_FETCH_SUCCESS = 'COMMENTS_FETCH_SUCCESS';
export interface CommentsFetchSuccessAction extends CommentsFetchAction, APISuccessAction<CommentsFetchNormalizedResponse> {
    readonly type: typeof COMMENTS_FETCH_SUCCESS;
    readonly canAdd: boolean;
}
export const COMMENTS_FETCH_FAILURE = 'COMMENTS_FETCH_FAILURE';
export interface CommentsFetchFailureAction extends CommentsFetchAction, APIFailureAction {
    readonly type: typeof COMMENTS_FETCH_FAILURE;
}

export const commentsFetch = {
    request: (key: string): CommentsFetchRequestAction => ({ type: COMMENTS_FETCH_REQUEST, key }),
    success: (key: string, canAdd: boolean, response: CommentsFetchNormalizedResponse): CommentsFetchSuccessAction => ({
        type: COMMENTS_FETCH_SUCCESS, key, canAdd, response,
    }),
    failure: (key: string, error: any): CommentsFetchFailureAction => ({ type: COMMENTS_FETCH_FAILURE, key, error }),
};

export interface PostCommentDeleteAction extends Action {
    readonly commentId: number;
    readonly key: string;
}

export interface CommentDeleteNormalizedResponse extends NormalizedResponse {
    readonly result: number;
}

export const COMMENT_DELETE_REQUEST = 'COMMENT_DELETE_REQUEST';
export interface CommentDeleteRequestAction extends PostCommentDeleteAction, APIRequestAction {
    readonly type: typeof COMMENT_DELETE_REQUEST;
}

export const COMMENT_DELETE_SUCCESS = 'COMMENT_DELETE_SUCCESS';
export interface CommentDeleteSuccessAction extends PostCommentDeleteAction, APISuccessAction<CommentDeleteNormalizedResponse> {
    readonly type: typeof COMMENT_DELETE_SUCCESS;
}

export const COMMENT_DELETE_FAILURE = 'COMMENT_DELETE_FAILURE';
export interface CommentDeleteFailureAction extends PostCommentDeleteAction, APIFailureAction {
    readonly type: typeof COMMENT_DELETE_FAILURE;
}

export const commentDeleteActions = {
    request: (commentId: number, key: string): CommentDeleteRequestAction => ({ type: COMMENT_DELETE_REQUEST, commentId, key }),
    success: (commentId: number, key: string, response: CommentDeleteNormalizedResponse): CommentDeleteSuccessAction => ({
        type: COMMENT_DELETE_SUCCESS, commentId, key, response,
    }),
    failure: (commentId: number, key: string, error: any): CommentDeleteFailureAction => ({
        type: COMMENT_DELETE_FAILURE, commentId, key, error,
    }),
};

export interface PostCommentCreateAction extends Action {
    readonly commentFd: CommentFormData;
    readonly key: string;
}

export interface CommentCreateNormalizedResponse extends NormalizedResponse {
    readonly result: number;
}

export const COMMENT_CREATE_REQUEST = 'COMMENT_CREATE_REQUEST';
export interface CommentCreateRequestAction extends PostCommentCreateAction, APIRequestAction {
    readonly type: typeof COMMENT_CREATE_REQUEST;
}

export const COMMENT_CREATE_SUCCESS = 'COMMENT_CREATE_SUCCESS';
export interface CommentCreateSuccessAction extends PostCommentCreateAction, APISuccessAction<CommentCreateNormalizedResponse> {
    readonly type: typeof COMMENT_CREATE_SUCCESS;
}

export const COMMENT_CREATE_FAILURE = 'COMMENT_CREATE_FAILURE';
export interface CommentCreateFailureAction extends PostCommentCreateAction, APIFailureAction {
    readonly type: typeof COMMENT_CREATE_FAILURE;
}

export const commentCreateActions = {
    request: (commentFd: CommentFormData, key: string): CommentCreateRequestAction => ({ type: COMMENT_CREATE_REQUEST, commentFd, key }),
    success: (commentFd: CommentFormData, key: string, response: CommentCreateNormalizedResponse): CommentCreateSuccessAction => ({
        type: COMMENT_CREATE_SUCCESS, commentFd, key, response,
    }),
    failure: (commentFd: CommentFormData, key: string, error: any): CommentCreateFailureAction => ({ type: COMMENT_CREATE_FAILURE, commentFd, key, error }),
};

// Comments load
export const COMMENTS_LOAD = 'COMMENTS_LOAD';
export interface CommentsLoadAction extends CommentsFetchAction {
    readonly type: typeof COMMENTS_LOAD;
}
export const commentsLoad = (key: string): CommentsLoadAction => ({
    type: COMMENTS_LOAD, key,
});

// Comment Delete
export const COMMENT_DELETE = 'COMMENT_DELETE';
export interface CommentDeleteAction extends PostCommentDeleteAction {
    readonly type: typeof COMMENT_DELETE;
}

export const commentDelete = (commentId: number, key: string): CommentDeleteAction => ({
    type: COMMENT_DELETE, commentId, key,
});

// Comment Create
export const COMMENT_CREATE = 'COMMENT_CREATE';
export interface CommentCreateAction extends PostCommentCreateAction {
    readonly type: typeof COMMENT_CREATE;
}

export const commentCreate = (commentFd: CommentFormData, key: string): CommentCreateAction => ({
    type: COMMENT_CREATE, commentFd, key,
});

export const COMMENT_REPLY = 'COMMENT_REPLY';

export interface CommentReplyAction extends Action {
    readonly type: typeof COMMENT_REPLY;
    readonly id: number;
    readonly username: string;
}

export const commentReply = (id: number, username: string): CommentReplyAction => ({
    type: COMMENT_REPLY, id, username,
});
